import React, { useState } from 'react';
import { convertToHumanReadableDate } from 'shared';

export const ProjectHeaderCard = HeaderCardModel => {
    const [cardTitle] = useState(HeaderCardModel.cardTitle);
    const [institution] = useState(HeaderCardModel.institution);
    const [biennium] = useState(HeaderCardModel.biennium);
    const [budgetAgencyProjectNo] = useState(HeaderCardModel.budgetAgencyProjectNo);
    const [institutionalPriority] = useState(HeaderCardModel.institutionalPriority);
    const [lastUpdated] = useState(HeaderCardModel.lastUpdated);
    return (
        <div className="card p-3 mb-3">
            <h2 className="text-strong text-primary">{cardTitle}</h2>
            <div className="d-md-flex justify-content-md-between justify-content-center align-items-center">
                <ul className="d-md-flex align-items-center mr-3 p-0 mb-0 no-bullets med-type">
                    <li className="mr-3">
                        <label className="m-0">Institution:</label> {institution}
                    </li>
                    <li className="mr-3">
                        <label className="m-0">Biennium:</label> {biennium}
                    </li>
                    <li className="mr-3">
                        <label className="m-0">Budget Agency Project No:</label>{' '}
                        {budgetAgencyProjectNo}
                    </li>
                    <li className="mr-3">
                        <label className="m-0">Institutional Priority:</label>{' '}
                        {institutionalPriority}
                    </li>
                    <li>
                        <label className="m-0">Last Updated:</label>{' '}
                        {convertToHumanReadableDate(lastUpdated)}
                    </li>
                </ul>
            </div>
        </div>
    );
};
